import {
  GetAllCoursesOutDto,
  GetOneCourseOutDto,
} from "../../types/course.dto";
import {
  GET_ALL_COURSES,
  RESET_GET_ALL_COURSES,
  GetAllCourses,
  ResetGetAllCourses,
} from "../types/course/get-all.dto";
import { GET_ONE_COURSE, GetOneCourse } from "../types/course/get-one.dto";

export const getAllCourses = (payload: GetAllCoursesOutDto): GetAllCourses => {
  return { type: GET_ALL_COURSES, payload };
};

export const resetGetAllCourses = (): ResetGetAllCourses => {
  return { type: RESET_GET_ALL_COURSES, payload: null };
};

export const getOneCourse = (payload: GetOneCourseOutDto): GetOneCourse => {
  return { type: GET_ONE_COURSE, payload };
};
